module.exports = __webpack_public_path__ + "static/media/promo-v2-8.a60883da.jpeg";